import {
    changeFormatter,
    sourceFormNameFormatter,
    templateCreatedChangeFormatter,
    templateNameFormatter,
    translationChangeFormatter,
    workflowNodeChangeFormatter,
} from './formatters';

import AddIcon from '@mui/icons-material/Add';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ComputerIcon from '@mui/icons-material/Computer';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ForumIcon from '@mui/icons-material/Forum';
import GavelIcon from '@mui/icons-material/Gavel';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import LanguageIcon from '@mui/icons-material/Language';
import MailIcon from '@mui/icons-material/Mail';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import MarkChatUnreadIcon from '@mui/icons-material/MarkChatUnread';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import PaletteIcon from '@mui/icons-material/Palette';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PolicyIcon from '@mui/icons-material/Policy';
import PortraitIcon from '@mui/icons-material/Portrait';
import PublishIcon from '@mui/icons-material/Publish';
import RestoreIcon from '@mui/icons-material/Restore';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import UpdateIcon from '@mui/icons-material/Update';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import moment from 'moment';
import palette from '/b2b/common/theme/palette';

export const PLATFORM_EVENTS = {
    COMMENT_CREATED: 'platform.commentCreated',
    WORKFLOW_NODE_CREATED: 'platform.workflowNodeCreated',
    WORKFLOW_NODE_DELETED: 'platform.workflowNodeDeleted',
    WORKFLOW_NODE_UPDATED: 'platform.workflowNodeUpdated',
    WORKFLOW_VERSION_PUBLISHED: 'platform.workflowVersionPublished',
};

export const DSAR_EVENTS = {
    ACTION_ITEMS_ASSIGNED: 'dsar.actionItemAssigned',
    ACTION_ITEMS_CREATED: 'dsar.actionItemsCreated',
    ACTION_ITEM_COMPLETED: 'dsar.actionItemCompleted',
    ACTION_ITEM_CREATED: 'dsar.actionItemCreated',
    ACTION_ITEM_OFFLINE_EVENT: 'dsar.actionItemOfflineNoteCreated',
    ACTION_ITEM_REOPENED: 'dsar.actionItemReopened',
    ACTION_ITEM_UNASSIGNED: 'dsar.actionItemUnassigned',
    APPROVAL_ACTION_ITEM_APPROVED: 'dsar.approvalActionItemApproved',
    APPROVAL_ACTION_ITEM_ASSIGNED: 'dsar.approvalActionItemAssigned',
    APPROVAL_ACTION_ITEM_CREATED: 'dsar.approvalActionItemCreated',
    APPROVAL_ACTION_ITEM_REJECTED: 'dsar.approvalActionItemRejected',
    APPROVAL_ACTION_ITEM_UNASSIGNED: 'dsar.approvalActionItemUnassigned',
    COMMENT_CREATED: PLATFORM_EVENTS.COMMENT_CREATED,
    MANUAL_ACTION_ITEM_ASSIGNED: 'dsar.manualActionItemAssigned',
    MANUAL_ACTION_ITEM_COMPLETED: 'dsar.manualActionItemCompleted',
    MANUAL_ACTION_ITEM_CREATED: 'dsar.manualActionItemCreated',
    MANUAL_ACTION_ITEM_REOPENED: 'dsar.manualActionItemReopened',
    MANUAL_ACTION_ITEM_UNASSIGNED: 'dsar.manualActionItemUnassigned',
    DSAR_APPEALED: 'dsar.appealed',
    DSAR_COMPLETED: 'dsar.completed',
    DSAR_COMPLETED_EMAIL_SENT: 'dsar.completedEmailSent',
    DSAR_CREATED_EMAIL_SENT: 'dsar.requestCreatedEmailSent',
    DSAR_EMAIL_VERIFIED: 'dsar.emailVerified',
    DSAR_EMAIL_INQUIRY_RECEIVED: 'dsar.intakeEmailReceived',
    DSAR_EMAIL_INQUIRY_RESPONSE: 'dsar.intakeEmailReplied',
    DSAR_IDENTITY_VERIFIED: 'dsar.identityVerified',
    DSAR_IN_PROGRESS: 'dsar.inProgress',
    DSAR_OFFLINE_EVENT: 'dsar.offlineNoteCreated',
    DSAR_PENDING_IDENTITY_VERIFICATION: 'dsar.pendingIdentityVerification',
    DSAR_READY_FOR_REVIEW: 'dsar.readyForReview',
    DSAR_REJECTED: 'dsar.rejected',
    DSAR_REJECTED_EMAIL_SENT: 'dsar.rejectedEmailSent',
    DSAR_REQUEST_CREATED: 'dsar.requestCreated',
    DSAR_REQUEST_MODIFIED: 'dsar.modifiedRequestInfo',
    DSAR_VERIFICATION_REMINDER_EMAIL_SENT: 'dsar.verificationReminderEmailSent',
    DSAR_VERIFIED_EMAIL_SENT: 'dsar.verifiedEmailSent',
    USER_PORTAL_MESSAGE_RECEIVED: 'dsar.portalMessageReceived',
    USER_PORTAL_MESSAGE_SENT: 'dsar.b2bPortalMessageSent',
    USER_PORTAL_MESSAGE_SENT_EMAIL_SENT: 'dsar.b2bPortalMessageSentEmailSent',
};

export const TRUSTHUB_EVENTS = {
    TRUSTHUB_PAGE_DELETED: 'trusthub.pageDeleted',
    TRUSTHUB_PAGE_UNPUBLISHED: 'trusthub.pagePrivate',
    TRUSTHUB_PAGE_PUBLISHED: 'trusthub.pagePublished',
    TRUSTHUB_PAGE_REVISION_RESTORED: 'trusthub.pageRevisionRestored',
    TRUSTHUB_PAGE_SCHEDULED_PUBLISH: 'trusthub.pageScheduledPublish',
    TRUSTHUB_PAGE_SCHEDULED_PUBLISH_CANCELLED: 'trusthub.pageScheduledPublishCanceled',
};
export const CONSENT_EVENT_TYPES = {
    CONFIG_PUBLISHED: 'cmp.configPublished',
    CONFIG_UPDATED: 'cmp.configUpdated',
    CONFIG_DELETED: 'cmp.configDeleted',
    CONFIG_COPIED: 'cmp.configCopied',
    CONFIG_CREATED: 'cmp.configCreated',
    RULE_CREATED: 'cmp.ruleCreated',
    RULE_UPDATED: 'cmp.ruleUpdated',
    RULE_DELETED: 'cmp.ruleDeleted',
    CONFIG_ROLLBACK: 'cmp.configRollback',
    SITEMAP_URL_CREATED: 'cmp.sitemapURLCreated',
    SITEMAP_URL_DELETED: 'cmp.sitemapURLDeleted',
    SITEMAP_URL_UPDATED: 'cmp.sitemapURLUpdated',
    URLSCAN_CREATED: 'cmp.urlScanCreated',
    URLSCAN_DELETED: 'cmp.urlScanDeleted',
    URLSCAN_UPDATED: 'cmp.urlScanUpdated',
};

export const DSAR_FORM_EVENTS = {
    FORM_CREATED: 'dsar.formCreated',
    FORM_UPDATED: 'dsar.formUpdated',
    FORM_DELETED: 'dsar.formDeleted',
    // Fields are entities, so they split per lifecycle action — the audit-log API
    // can filter by event type (e.g. "only field additions").
    FORM_FIELD_CREATED: 'dsar.formFieldCreated',
    FORM_FIELD_UPDATED: 'dsar.formFieldUpdated',
    FORM_FIELD_DELETED: 'dsar.formFieldDeleted',
    // Templates split per lifecycle action, each carrying a metadata.changes[] diff.
    FORM_TEMPLATE_CREATED: 'dsar.formTemplateCreated',
    FORM_TEMPLATE_UPDATED: 'dsar.formTemplateUpdated',
    FORM_TEMPLATE_DELETED: 'dsar.formTemplateDeleted',
    // Request types can only be updated (reordered, toggled, verification edited),
    // so there is a single updated event carrying the per-attribute diff.
    FORM_REQUEST_TYPE_UPDATED: 'dsar.formRequestTypeUpdated',
    FORM_LOCALIZATION_UPDATED: 'dsar.formLocalizationUpdated',
    FORM_COPIED: 'dsar.formCopied',
};

// DSAR form Activity Log icon colors — Osano design-system tokens, one per action
// so the colour alone says what happened to the form, its fields or its templates.
// `color` is the glyph; `backgroundColor` is the opaque circle tint (the design
// system's *-bg token, not an alpha of the glyph). Not in the shared MUI palette,
// so set directly.
const DSAR_FORM_ICON = {
    created: { color: '#016630', backgroundColor: '#DCFCE7' }, // success-strong / success-bg
    updated: { color: '#5424A4', backgroundColor: '#EBE0FE' }, // osano-700 / osano-100
    deleted: { color: '#9F0712', backgroundColor: '#FFE2E2' }, // error-strong / error-bg
};

export const TEXT_CUSTOMIZATION_CHANGE_KEYS = {
    MESSAGING: 'messaging',
    BUTTONS: 'buttons',
    ALERTS: 'alerts',
    CATEGORIES: 'categories',
    DRAWER: 'drawer',
    DO_NOT_SELL: 'doNotSell',
    LABELS: 'labels',
    NOTIFICATIONS: 'notifications',
    MODALS: 'modals',
    FORMS: 'forms',
};

export const CONSENT_CHANGE_TYPES = {
    TEXT_CUSTOMIZATION: 'TextCustomization',
    STYLE: 'Style',
    IAB: 'IAB',
    SETTING: 'Setting',
    RULE: 'Rule',
};

export const EVENTS = {
    [PLATFORM_EVENTS.COMMENT_CREATED]: {
        color: palette.data3.main,
        icon: ForumIcon,
    },
    [DSAR_EVENTS.ACTION_ITEMS_ASSIGNED]: {
        color: palette.info.light,
        icon: ArrowRightAltIcon,
    },
    [DSAR_EVENTS.ACTION_ITEMS_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_COMPLETED]: {
        color: palette.success.light,
        icon: CheckIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_OFFLINE_EVENT]: {
        color: palette.info.light,
        icon: EventNoteIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_REOPENED]: {
        color: palette.info.light,
        icon: MarkAsUnreadIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_UNASSIGNED]: {
        color: palette.info.light,
        icon: PersonRemoveIcon,
    },
    [DSAR_EVENTS.MANUAL_ACTION_ITEM_ASSIGNED]: {
        color: palette.info.light,
        icon: ArrowRightAltIcon,
    },
    [DSAR_EVENTS.MANUAL_ACTION_ITEM_COMPLETED]: {
        color: palette.success.light,
        icon: CheckIcon,
    },
    [DSAR_EVENTS.MANUAL_ACTION_ITEM_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.MANUAL_ACTION_ITEM_REOPENED]: {
        color: palette.info.light,
        icon: MarkAsUnreadIcon,
    },
    [DSAR_EVENTS.MANUAL_ACTION_ITEM_UNASSIGNED]: {
        color: palette.info.light,
        icon: PersonRemoveIcon,
    },
    [DSAR_EVENTS.APPROVAL_ACTION_ITEM_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.APPROVAL_ACTION_ITEM_ASSIGNED]: {
        color: palette.info.light,
        icon: ArrowRightAltIcon,
    },
    [DSAR_EVENTS.APPROVAL_ACTION_ITEM_APPROVED]: {
        color: palette.success.light,
        icon: CheckIcon,
    },
    [DSAR_EVENTS.APPROVAL_ACTION_ITEM_REJECTED]: {
        color: palette.error.light,
        icon: CloseIcon,
    },
    [DSAR_EVENTS.APPROVAL_ACTION_ITEM_UNASSIGNED]: {
        color: palette.info.light,
        icon: PersonRemoveIcon,
    },
    [DSAR_EVENTS.DSAR_APPEALED]: {
        color: palette.warning.light,
        icon: GavelIcon,
    },
    [DSAR_EVENTS.DSAR_COMPLETED]: {
        color: palette.success.main,
        icon: CelebrationIcon,
    },
    [DSAR_EVENTS.DSAR_COMPLETED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_CREATED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_VERIFIED]: {
        color: palette.success.main,
        icon: MarkEmailReadIcon,
    },
    [DSAR_EVENTS.DSAR_IN_PROGRESS]: {
        color: palette.common.magenta,
        icon: TimelapseIcon,
    },
    [DSAR_EVENTS.DSAR_OFFLINE_EVENT]: {
        color: palette.info.light,
        icon: EventNoteIcon,
    },
    [DSAR_EVENTS.DSAR_PENDING_IDENTITY_VERIFICATION]: {
        color: palette.warning.light,
        icon: PortraitIcon,
    },
    [DSAR_EVENTS.DSAR_IDENTITY_VERIFIED]: {
        color: palette.success.main,
        icon: InsertEmoticonIcon,
    },
    [DSAR_EVENTS.DSAR_READY_FOR_REVIEW]: {
        color: palette.secondaryLight.light,
        icon: AssignmentIcon,
    },
    [DSAR_EVENTS.DSAR_REJECTED]: {
        color: palette.error.main,
        icon: CloseIcon,
    },
    [DSAR_EVENTS.DSAR_REJECTED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_REQUEST_CREATED]: {
        color: palette.warning.light,
        icon: ComputerIcon,
    },
    [DSAR_EVENTS.DSAR_REQUEST_MODIFIED]: {
        color: palette.warning.light,
        icon: EditIcon,
        formatter: {
            modifiedFields: (modifiedFields, auditEventData = {}) => {
                if (!Array.isArray(modifiedFields) || modifiedFields.length === 0) {
                    return '';
                }

                const { newValues = {}, previousValues = {} } = auditEventData;

                const listItems = modifiedFields
                    .map(field => {
                        const oldValue = previousValues[field] ?? '';
                        const newValue = newValues[field] ?? '';
                        return `<li><b>${field}</b> from <i>${oldValue}</i>  to <i>${newValue}</i></li>`;
                    })
                    .join('');

                return `[html]<ul>${listItems}</ul>[/html]`;
            },
        },
    },
    [DSAR_EVENTS.DSAR_VERIFICATION_REMINDER_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_VERIFIED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_RECEIVED]: {
        color: palette.info.light,
        icon: MarkChatUnreadIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_SENT]: {
        color: palette.primary.light,
        icon: ModeCommentIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_SENT_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_INQUIRY_RECEIVED]: {
        color: palette.info.light,
        icon: EmailIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_INQUIRY_RESPONSE]: {
        color: palette.info.light,
        icon: SendIcon,
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_PUBLISHED]: {
        color: palette.success.main,
        icon: PublishIcon,
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_UNPUBLISHED]: {
        color: palette.common.grey[500],
        icon: VisibilityOffIcon,
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_SCHEDULED_PUBLISH]: {
        color: palette.warning.light,
        icon: ScheduleIcon,
        formatter: {
            scheduledTime: val => moment(val).format('MM/DD/YYYY @ h:mma'),
        },
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_SCHEDULED_PUBLISH_CANCELLED]: {
        color: palette.error.main,
        icon: EventBusyIcon,
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_DELETED]: {
        color: palette.error.main,
        icon: DeleteIcon,
    },
    [TRUSTHUB_EVENTS.TRUSTHUB_PAGE_REVISION_RESTORED]: {
        color: palette.info.light,
        icon: RestoreIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_PUBLISHED]: {
        color: palette.success.main,
        icon: LanguageIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_UPDATED]: {
        color: palette.data5.main,
        icon: UpdateIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_DELETED]: {
        color: palette.error.main,
        icon: DeleteOutlineIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_COPIED]: {
        color: palette.data5.main,
        icon: ContentCopyIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_CREATED]: {
        color: palette.data5.main,
        icon: AddIcon,
    },
    [CONSENT_EVENT_TYPES.CONFIG_ROLLBACK]: {
        color: palette.data5.main,
        icon: RestoreIcon,
    },
    [CONSENT_EVENT_TYPES.RULE_CREATED]: {
        color: palette.warning.main,
        icon: AddIcon,
    },
    [CONSENT_EVENT_TYPES.RULE_UPDATED]: {
        color: palette.warning.main,
        icon: UpdateIcon,
    },
    [CONSENT_EVENT_TYPES.RULE_DELETED]: {
        color: palette.warning.main,
        icon: DeleteOutlineIcon,
    },
    [CONSENT_EVENT_TYPES.SITEMAP_URL_CREATED]: {
        color: palette.data8.main,
        icon: AddIcon,
    },
    [CONSENT_EVENT_TYPES.SITEMAP_URL_DELETED]: {
        color: palette.data8.main,
        icon: DeleteOutlineIcon,
    },
    [CONSENT_EVENT_TYPES.SITEMAP_URL_UPDATED]: {
        color: palette.data8.main,
        icon: UpdateIcon,
    },
    [CONSENT_EVENT_TYPES.URLSCAN_CREATED]: {
        color: palette.data4.main,
        icon: AddIcon,
    },
    [CONSENT_EVENT_TYPES.URLSCAN_DELETED]: {
        color: palette.data4.main,
        icon: DeleteOutlineIcon,
    },
    [CONSENT_EVENT_TYPES.URLSCAN_UPDATED]: {
        color: palette.data4.main,
        icon: SettingsIcon,
    },
    [DSAR_FORM_EVENTS.FORM_CREATED]: {
        ...DSAR_FORM_ICON.created,
        icon: AddIcon,
    },
    [DSAR_FORM_EVENTS.FORM_UPDATED]: {
        ...DSAR_FORM_ICON.updated,
        icon: UpdateIcon,
        // formUpdated carries its diff at metadata.changes[]; the shared
        // changeFormatter renders each change as struck-through old → new chips.
        formatter: { changes: changeFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_DELETED]: {
        ...DSAR_FORM_ICON.deleted,
        icon: DeleteOutlineIcon,
    },
    // Field events all carry a one-field diff at metadata.changes[]; color/icon
    // mirror the form lifecycle (created green / updated brand / deleted red).
    [DSAR_FORM_EVENTS.FORM_FIELD_CREATED]: {
        ...DSAR_FORM_ICON.created,
        icon: AddIcon,
        formatter: { changes: changeFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_FIELD_UPDATED]: {
        ...DSAR_FORM_ICON.updated,
        icon: EditIcon,
        formatter: { changes: changeFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_FIELD_DELETED]: {
        ...DSAR_FORM_ICON.deleted,
        icon: DeleteOutlineIcon,
        formatter: { changes: changeFormatter },
    },
    // Template events read by action like every other form event — a removed
    // template has to look removed — with the icon naming what was touched. Each
    // carries a per-template diff at metadata.changes[].
    [DSAR_FORM_EVENTS.FORM_TEMPLATE_CREATED]: {
        ...DSAR_FORM_ICON.created,
        icon: AddIcon,
        formatter: { changes: templateCreatedChangeFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_TEMPLATE_UPDATED]: {
        ...DSAR_FORM_ICON.updated,
        icon: MailIcon,
        formatter: { changes: changeFormatter },
    },
    // The sentence names the template it removed, so there is no change list.
    [DSAR_FORM_EVENTS.FORM_TEMPLATE_DELETED]: {
        ...DSAR_FORM_ICON.deleted,
        icon: DeleteOutlineIcon,
        formatter: { templateName: templateNameFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_REQUEST_TYPE_UPDATED]: {
        ...DSAR_FORM_ICON.updated,
        icon: AssignmentIcon,
        formatter: { changes: changeFormatter },
    },
    [DSAR_FORM_EVENTS.FORM_LOCALIZATION_UPDATED]: {
        ...DSAR_FORM_ICON.updated,
        icon: LanguageIcon,
        // Lists the text a save put on the translation queue rather than a change to
        // it, so its rows show that text alone instead of a previous → new diff.
        formatter: { changes: translationChangeFormatter },
    },
    // Copying a form is a creation-like event with no field diff; the desc names
    // the source form from metadata.sourceFormName.
    [DSAR_FORM_EVENTS.FORM_COPIED]: {
        ...DSAR_FORM_ICON.created,
        icon: ContentCopyIcon,
        formatter: { sourceFormName: sourceFormNameFormatter },
    },
    [PLATFORM_EVENTS.WORKFLOW_VERSION_PUBLISHED]: {
        color: palette.success.main,
        icon: PublishIcon,
    },
    [PLATFORM_EVENTS.WORKFLOW_NODE_CREATED]: {
        color: palette.success.main,
        icon: AddTaskIcon,
        formatter: workflowNodeChangeFormatter,
    },
    [PLATFORM_EVENTS.WORKFLOW_NODE_UPDATED]: {
        color: palette.data5.main,
        icon: UpdateIcon,
        formatter: workflowNodeChangeFormatter,
    },
    [PLATFORM_EVENTS.WORKFLOW_NODE_DELETED]: {
        color: palette.error.light,
        icon: DeleteOutlineIcon,
        formatter: workflowNodeChangeFormatter,
    },
};

export const RESOURCE_TYPES = {
    CMP: 'CMP',
    DSAR: 'DSAR',
    DSAR_FORM: 'DSAR_FORM',
    PLATFORM: 'PLATFORM',
    TRUSTHUB_PAGE: 'TRUSTHUB_PAGE',
};

export const RESOURCE_TYPE_PATHS = {
    [RESOURCE_TYPES.DSAR]: `${AuthenticatedPaths.DSAR_REQUESTS}/:resourceId`,
};

export const AUDIT_USER_REPLACEMENTS = {
    API_USER: 'common.apiUser',
    AUTOMATION: 'common.automation',
};

// 'dsar.requestCreated' exists and can't be duplicated with another description in the db
// due to constraints on the audit event type table,
// so we augment the existing creation event with a new description for csv imports,
// since this isn't a new event anyway, just different text for Request Created
export const AUDIT_EVENT_DESCRIPTIONS = {
    DSAR_REQUEST_CREATED_CSV: 'dsar.requestCreated.auditEventDescCSV',
};

export const DSAR_REQUEST_SOURCES = {
    CSV: 'CSV',
};

export const CHANGE_ICONS = {
    Style: PaletteIcon,
    TextCustomization: CreateIcon,
    IAB: PolicyIcon,
    Setting: UpdateIcon,
    Rule: GavelIcon,
};

export const CHANGE_COLORS = {
    Style: palette.data2.main, // Purple for style changes
    TextCustomization: palette.data3.main, // Teal for text customizations
    IAB: palette.data4.main, // Orange for IAB changes
    Setting: palette.data5.main, // Pink for setting changes
    Rule: palette.warning.main, // Amber for rule changes (matches rule events)
};
